import { useDispatch as reduxUseDispatch } from 'react-redux';

import type { AppDispatch } from '@/redux/store';

export const useDispatch = reduxUseDispatch.withTypes<AppDispatch>();
